import { type Route } from '@angular/router';
import { CallbackComponent } from './features/callback/callback.component';
import { authGuard } from './core/guards/auth.guard';
import { ReRouteComponent } from './features/re-route/re-route.component';
import { WithNavigationComponent } from './features/with-navigation/with-navigation.component';
import { requirePermissions } from './core/guards/permissions.guard';
import { ErrorPageComponent } from './features/error-page/error-page.component';
import { tenantGuard } from './core/guards/tenant.guard';
import { onboardGuard } from './core/guards/onboard.guard';
import { eulaGuard } from './core/guards/eula.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    component: ReRouteComponent,
  },
  {
    path: '',
    canActivate: [authGuard, requirePermissions(), tenantGuard, eulaGuard, onboardGuard],
    loadChildren: () => [
      {
        path: '',
        component: WithNavigationComponent,
        loadChildren: () => [
          {
            path: 'dashboard',
            canActivate: [requirePermissions('DASHBOARD_READ')],
            loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.routes),
          },
          {
            path: 'slides',
            canActivate: [requirePermissions('SLIDE_SCANS_READ')],
            loadChildren: () => import('./features/slides/slides.routes').then((m) => m.routes),
          },
          {
            path: 'setup',
            canActivate: [requirePermissions('SETUP_READ')],
            loadChildren: () => import('./features/setup/setup.routes').then((m) => m.routes),
          },
          {
            path: 'user-management',
            canActivate: [requirePermissions('USER_MANAGEMENT_WRITE')],
            loadChildren: () => import('./features/user-management/user-management.routes').then((m) => m.routes),
          },

        ],
      },
      {
        path: 'slides/detail/:scanId',
        canActivate: [requirePermissions('SLIDE_SCANS_READ')],
        loadChildren: () => import('./features/slide-scan-detail/slide-scan-detail.routes').then((m) => m.routes),
      },
    ],
  },
  {
    path: 'onboard/dataplane',
    canActivate: [authGuard, eulaGuard, requirePermissions('SETUP_WRITE')],
    loadChildren: () => import('./features/onboard-dataplane/onboard-dataplane.routes').then((m) => m.routes),
  },
  {
    path: 'tenant/selection',
    canActivate: [authGuard],
    loadChildren: () => import('./features/tenant-selection/tenant-selection.routes').then((m) => m.routes),
  },
  {
    path: 'eula',
    canActivate: [authGuard],
    loadChildren: () => import('./features/eula/eula.routes').then((m) => m.routes),
  },
  {
    path: 'callback',
    loadComponent: () => CallbackComponent,
  },
  {
    matcher: (segments) => {
      // error/403 or error/404
      if (segments.length === 2 && segments[0].path === 'error' && ['403', '404'].includes(segments[1].path)) {
        return { consumed: segments, posParams: { 'error-code': segments[1] } };
      }
      return null;
    },
    component: ErrorPageComponent,
  },
  {
    path: '**',
    redirectTo: '/error/404',
  },
];
